import AxiosCustom from "../../common/components/apiConfig";

export async function LogOutApi(item) {
  let config = {
    url: "logout",
  };

  let data = {
    method_type: "logout",
    data: {
      ...item,
    },
  };

  return await AxiosCustom(config, data);
}
